var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { EventTerminal } from "./primitives/EventTerminal.mjs";
import { TelemetryServiceOutgoingEvent, TelemetryServiceEvent } from "./types/events.mjs";
class TelemetryClient {
  constructor() {
    __publicField(this, "terminal");
    this.terminal = new EventTerminal(TelemetryServiceOutgoingEvent);
  }
  report(reportData, options) {
    this.terminal.emit(TelemetryServiceEvent.Report, { data: reportData, options });
  }
  reportText(text, options) {
    this.terminal.emit(TelemetryServiceEvent.ReportText, { data: text, options });
  }
  updateMeta(meta) {
    this.terminal.emit(TelemetryServiceEvent.UpdateMeta, { meta });
  }
  flush() {
    this.terminal.emit(TelemetryServiceEvent.Flush);
  }
  addEventListener(eventName, handler) {
    this.terminal.addEventListener(eventName, handler);
  }
  removeEventListener(eventName, handler) {
    this.terminal.removeEventListener(eventName, handler);
  }
}
export {
  TelemetryClient
};
